import styled from "styled-components";
import { Switch, FormControlLabel } from "@mui/material";

export const StyledSwitch = styled(Switch)`
  &.MuiSwitch-root {
    & span {
      &.MuiSwitch-thumb {
        width: 13px;
        height: 13px;
        margin-top: 3px;
        margin-left: 4px;
      }
      /*&.MuiSwitch-track + &.Mui-checked {
        background-color: ${({ theme }) => {
        return theme.colors.green;
      }};
      }*/
    }
  }
`;

export const SwitchFieldLabel = styled(FormControlLabel)`
  & span {
    &.MuiTypography-root {
      text-align: left;
      font: normal normal normal 16px Open Sans;
      color: ${({ theme }) => {
        return theme.colors.title;
      }};
      text-transform: capitalize;
    }
  }
`;